module.exports = __webpack_public_path__ + "img/ic-defauts-visuels-64.f318d35c.svg";